/* eslint-disable react/prop-types */
import React from "react";
import { Typography, makeStyles, withStyles } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

const useStyles = makeStyles(() => ({
  button: {
    textTransform: "none",
    flex: 1,
    padding: "7px 25px",
    width: "50%",
  },
}));

const StyledToggleButton = withStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    "&.Mui-selected": {
      color: "white",
      backgroundColor: theme.palette.primary.main,
      border: "none",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        cursor: "default",
      },
    },
  },
}))(ToggleButton);

const ScenarioTypeToggle = ({
  onChange,
  defaultType = "custom",
  disabledButtons = {},
}) => {
  const classes = useStyles();
  const [selectedType, setSelectedType] = React.useState(defaultType);

  const handleToggleChange = (_e, type) => {
    if (type !== null) setSelectedType(type);
  };

  React.useEffect(() => {
    if (onChange) onChange(selectedType);
  }, [selectedType]);

  React.useEffect(() => {
    if (
      disabledButtons.custom &&
      !disabledButtons.reference &&
      selectedType === "custom"
    )
      setSelectedType("reference");
    if (
      disabledButtons.reference &&
      !disabledButtons.custom &&
      selectedType !== "reference"
    )
      setSelectedType("custom");
  }, [disabledButtons]);

  return (
    <ToggleButtonGroup
      exclusive
      onChange={handleToggleChange}
      value={selectedType}
      size="small"
      style={{ display: "flex" }}
    >
      <StyledToggleButton
        className={classes.button}
        value="reference"
        disabled={disabledButtons.reference}
      >
        <Typography variant="body2">Reference</Typography>
      </StyledToggleButton>
      <StyledToggleButton
        className={classes.button}
        value="custom"
        disabled={disabledButtons.custom}
      >
        <Typography variant="body2">Custom</Typography>
      </StyledToggleButton>
    </ToggleButtonGroup>
  );
};

export default ScenarioTypeToggle;
